import { Badge, List } from '@mantine/core';
import { Check } from 'lucide-react';
import { TBillingSubscriptionInfo } from '@newo/api/gateway';
import dayjs from '@/libs/dayjs';
// mantine
// components
import BillingMenu from '@/pages/Profile/components/Billing/components/BillingMenu';
import UnitsProgress from '@/pages/Profile/components/Billing/components/UnitsProgress';
// icons
// utils

interface TrialSubscriptionProps {
    data: TBillingSubscriptionInfo;
    unitsSpent: number;
    onCancel: () => void;
}

const TrialSubscription = ({
    data,
    unitsSpent,
    onCancel
}: TrialSubscriptionProps) => {
    const daysDiff = dayjs(data.trial_end).diff(dayjs(), 'day');
    const diff = Math.floor(daysDiff);
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
                <div className="text-xl font-bold mb-4 flex items-start gap-2">
                    <div>{data.product_name}</div>

                    <Badge
                        className="capitalize shrink-0"
                        color="yellow"
                        variant="light"
                    >
                        {`Trial: ${diff} day${diff > 1 ? 's' : ''} left`}
                    </Badge>
                </div>
                <List center icon={<Check />} size="sm" spacing="sm">
                    <List.Item>
                        Test everything in Developer Mode (with a short intro
                        message before results)
                    </List.Item>
                    <List.Item>
                        Start your trial for results without the intro message.
                    </List.Item>
                    <List.Item>Unlimited Units Used</List.Item>
                </List>
            </div>
            <div className="flex flex-col justify-between items-end gap-4">
                <BillingMenu onCancel={onCancel} />
                <UnitsProgress
                    className="w-full"
                    max={data.product_units}
                    min={0}
                    value={unitsSpent}
                />
            </div>
        </div>
    );
};

export default TrialSubscription;
